import { useNavigate, useLocation } from 'react-router-dom'
import { ArrowLeft } from '@phosphor-icons/react'
import LangToggle from '../LangToggle/LangToggle'
import logo from '../../assets/images/logo.png'

export default function KioskHeader({ title = 'PBB N22 Kedup', subtitle = 'Mansang Kedup, Mansang' }) {
  const navigate = useNavigate()
  const location = useLocation()
  const isHome = location.pathname === '/'

  return (
    <header className="kiosk-header">
      <div className="kiosk-header__left">
        {!isHome && (
          <button type="button" className="kiosk-header__back" onClick={() => navigate('/')}>
            <ArrowLeft size={22} />
          </button>
        )}

        <button type="button" className="kiosk-header__brand" onClick={() => navigate('/')}>
          <span className="kiosk-header__logo">
            <img src={logo} alt="PBB N22 Kedup" />
          </span>
          <span>
            <strong>{title}</strong>
            <small>{subtitle}</small>
          </span>
        </button>
      </div>

      <LangToggle />
    </header>
  )
}
